var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "c--ui_checkmark checkbox tw-relative tw-flex tw-items-center tw-gap-4 tw-m-0 tw-cursor-pointer tw-select-none"
  }, [_c('input', {
    staticClass: "tw-absolute tw-opacity-0 cursor-pointer tw-h-0 tw-w-0",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.value
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('change', !_vm.value);
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark tw-relative tw-flex tw-flex-shrink-0 tw-w-[28px] tw-h-[28px] tw-bg-[#4A4A4C] tw-rounded-[7px]"
  }), _vm._v(" "), _vm.label ? [_c('span', {
    staticClass: "checkmark-label tw-text-[#8A8A8A] tw-text-[14px]/[20px]"
  }, [_vm._v("\n      " + _vm._s(_vm.label) + "\n    ")])] : _vm._e()], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }